<div fxLayout="column" fxLayoutAlign="space-between start" class="container">
  <div class="header">
    <div class="title" *ngIf="hospitalsSelected && compatible">Plusieurs services sélectionnés</div>
    <div class="title" *ngIf="!hospitalsSelected && compatible">Aucun service sélectionné</div>
    <div class="title" *ngIf="!compatible">Services incompatibles</div>
  </div>
  <div class="description" *ngIf="hospitalsSelected && compatible">
    Plusieurs services sont actuellement sélectionnés. Veuillez n'en sélectionner qu'un ci-dessous pour accéder à cette
    page.
  </div>
  <div class="description" *ngIf="!hospitalsSelected && compatible">
    Aucun services n'est actuellement sélectionné. Veuillez n'en sélectionner qu'un ci-dessous pour accéder à cette
    page.
  </div>
  <div class="description" *ngIf="!compatible">
    Les services sélectionnés ne sont pas compatibles. Veuillez n'en sélectionner qu'un ci-dessous pour accéder à cette
    page.
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="end center" class="select-container select-hospital-container">
      <mat-select
        [ngModel]="selectedHospital"
        (ngModelChange)="onChangeHospital($event)"
        placeholder="Services"
        hideSingleSelectionIndicator
      >
        <mat-option *ngFor="let i of hospitals" [value]="i" class="hospital-mat-option">
          <!-- {{ i.name }} -->
          {{ i.displayName }}
        </mat-option>
      </mat-select>
    </div>
    <app-button (click)="close()" text="Annuler" btnType="text" class="cancel-button"></app-button>
  </div>
</div>
